import * as Yup from "yup";

export const LoginSchema = Yup.object({
  userName: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});

export const ForgotPasswordSchema = Yup.object({
  email: Yup.string().email().required("Required"),
});

export const ResetPasswordSchema = Yup.object({
  password: Yup.string().required("Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Required"),
});

export const ManagerSchema = Yup.object({
  password: Yup.string().required("Required"),
  userName: Yup.string().required("Required"),
  address: Yup.object().shape({
    state: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
  }),
});

export const AgentSchema = Yup.object({
  password: Yup.string().required("Required"),
  parentId: Yup.string().required("Required"),
  userName: Yup.string().required("Required"),
  address: Yup.object().shape({
    state: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
  }),
});

export const SupervisorSchema = Yup.object({
  password: Yup.string().required("Required"),
  parentId: Yup.string().required("Required"),
  userName: Yup.string().required("Required"),
  address: Yup.object().shape({
    state: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
  }),
});

export const SubAdminSchema = Yup.object({
  name: Yup.string().required("Required"),
  userName: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});

export const SuperAdminSchema = Yup.object({
  userName: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});

export const SendNotifySchema = Yup.object({
  title: Yup.string()
    .transform((value) => value.trim())
    .required("Required"),
  body: Yup.string()
    .transform((value) => value.trim())
    .required("Required"),
});

export const CMSSchema = Yup.object({
  title: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
});

export const TrasnferAccSchema = Yup.object({
  transferToId: Yup.string().required("Required"),
});

export const ConfigSchema = Yup.object({
  value: Yup.string().required("Required"),
});

export const AppVersionSchema = Yup.object({
  platform: Yup.string().required("Required"),
  currentVersion: Yup.string().required("Required"),
  buildNumber: Yup.number().required("Required"),
  minSupportedVersion: Yup.string().required("Required"),
  minSupportedBuildNumber: Yup.number().required("Required"),
  updateUrl: Yup.string().url("Invalid URL").required("Required"),
  isSkippable: Yup.boolean().required("Required"),
  releaseNotes: Yup.string().required("Required"),
});
